import withAuth from '../../common/helper/auth-component.js';
import { connect } from 'react-redux';
import DataTable from 'react-data-table-component';
import React, { useState, useEffect } from 'react';
import DashboardService from '../../../services/dashboard-service.js';
import LoaderOverlay from '../../common/helper/loader.component.js';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import MerchantsService from "../../../services/merchants-service.js";
import { agentsList } from "../../../actions/agent-actions.js";
import { useSelector, useDispatch } from 'react-redux';
import StatusBadge from '../../common/helper/transaction-status.component.js';
import { initialFormData, initialErrors, fieldValidation  } from '../../common/helper/form-constants.js';
import ConfigService from '../../../services/config-service.js';
import { MESSAGES } from '../../constants/constants.js';

const RaisedTransactionList = () => { 
  const [errors, setErrors] = useState({ ...initialErrors });
  const [distributors, setDistributors] = useState([]);

  const dispatch = useDispatch();
  const [role,setUserRole] = useState('');
  const [status,setStatus] = useState('RAISED');

  const [loading, setLoading] = useState(false);
  const [transaction , setTransactionData] = useState();
  const [dataTableKey, setDataTableKey] = useState(0);
  const navigate = useNavigate();
  const userData = useSelector(state => state.authReducer);
  const [rowsPerPage, setRowsPerPage] = useState(200);
  const [pageNo, setPageNo] = useState(0);
  const [totalRows, setTotalRows] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [agents, setAgents] = useState([]);
  const [merchants, setMerchants] = useState([]);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const paginationComponentOptions = { 
    noRowsPerPage :true
  }
  const [filterData, setFilterData] = useState({
    end_date: '',
    start_date: '',
    merchantID: '',
    agentID: '',
    paymentType: '',
    status: 'RAISED'
  });
  const [columns, setColumns] = useState([
    {
      name: 'Order ID',
      cell: row => <div className="custom-cell-order_Code"><a href="javascript:void(0)" onClick={() => viewTransaction(row.transaction_id)}>{row.order_code}</a></div>,
      sortable: true,
     
    },
    {
      name: 'Payment Type',
      selector: row => <>
      <div style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }}><i className="fa fa-money me-1" style={{ color: row.transaction_type.toLowerCase() === 'payin' ? 'green' : 'red' }} />
      {row.transaction_type.toLowerCase().charAt(0).toUpperCase() + row.transaction_type.toLowerCase().slice(1)}
      </div>
      </>,
      sortable: true,
    },
    {
      name: 'Date',
      selector: row => <div className="custom-cell-order_Code">{row.start_date}</div>,
      sortable: true,
    },
    {
      name: 'Status',
      selector: row => 
      <>
      <StatusBadge status={row.status} />

      </>,
      
      sortable: true,
    },
    {
      name: 'Amount',
      selector: row => '₹' + row.amount,
      sortable: true,
    },
    {
      name: 'Payment Method',
      selector: row => 
      <>
      <i className={`fa  me-1 ${
        row.payment_method && row.payment_method.toLowerCase() === 'imps' ? 'fa-money' :
                            row.payment_method && row.payment_method.toLowerCase() === 'wallet' ? 'fa-credit-card' :
                            row.payment_method && row.payment_method.toLowerCase() === 'upi' ? 'fa-google-wallet' :
                            row.payment_method && row.payment_method.toLowerCase() === 'qr' ? 'fa-qrcode ' :
                            ''}`} /> {row.payment_method}
      
      </>
      
      ,
      sortable: true,
    },
    {
      name: 'Actions',
      selector: row => <>

      <div  style={{display:'flex'}}>
      
        <a className="fview tooltip" style={{'cursor':'pointer'}} onClick={() => {
          viewTransaction(row.transaction_id);
        }}>
          <i className="fa fa-eye" />
          <span className="tooltiptext"  >View</span>
        </a>
        {row.status =='P' && ( 
          <>
        <a className="tooltip dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fa fa-ellipsis-v" aria-hidden="true"  style={{color:'black'}}/>
          <span className="tooltiptext">More</span>
        </a>
        <ul className="dropdown-menu transaction dropdown-menu-end mbv" id="nvb" aria-labelledby="navbarDropdown">
          <li onClick={() => {
          confirm(row.transaction_id, row.order_code);
        }}>
            <a className="dropdown-item"  style={{cursor:'pointer',fontSize: '13px'}}>Confirm</a>
          </li>
          <li onClick={() => {
          raised(row.transaction_id, row.order_code);
        }}>
            <a className="dropdown-item"  style={{cursor:'pointer',fontSize: '13px'}}>Raised</a>
          </li>
        </ul></>
        )}
        </div>
      </>
    },
  ]);
const viewTransaction = (id) => {
  navigate(`/transaction/${id}`)
}

const confirm = (id,orderCode) => {
  navigate(`/confirm-transaction/${id}/${orderCode}}`)
}

const raised = (id,orderCode) => {
  navigate(`/raised-transaction/${id}/${orderCode}`)
 
}
const viewAgent = (row) => {
  let id=row.sender_id
  if(row.transaction_type == "PAYIN") {
    id = row.receiver_id
  }
  

navigate('/view-agent/'+id)
}

  const listTransactions = (fiterReset = false, pageNumber, rowsPage, status) => {
    setStatus(status)
    console.log(status)
    let userRole = '';
    let transaction =  DashboardService.getRaisedTransactions(fiterReset ? {status:status} : filterData, pageNumber, rowsPage, status)
    if(userData.user.data) {
      userRole = userData.user.data.role
    }
    if(userRole == 'ADMIN') {
    //  transaction =  DashboardService.getTransactionsListAdmin()
    }
    setLoading(true);
   
    transaction.then(response => {
      console.log(response)
      const records = response.data.data.list
      
      setTotalRows(response.data.data.total_records)



      setTransactionData(records)
      setLoading(false);
    })
    .catch(error => {
      setLoading(false);
      try {
        const errorMessage = error.response.data
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR)
      } catch (e){
        toast.error( MESSAGES.SERVER_ERROR)
      }
    });
  }

  const getDistributorList = (e) => {
    setLoading(true);
    ConfigService.getDistributorDropDown()
    .then((response) => {
        const disb = response.data.data;
        const arr = [{name:'All Distributors',value:''}];
        for(var i=0; i<disb.length; i++) {
        
            arr.push({
              name: disb[i].value,
              value: disb[i].key,
            })
        }
        setDistributors(arr);
   
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
  }

  const getAgents = () => {
    setLoading(true);
    ConfigService.getAgentsDropDown()
    .then((response) => {
      const agents = response.data.data
      const arr = [{name:'All Agents',value:''}];
      for(var i=0; i<agents.length; i++) {
        arr.push({
          name: agents[i].value,
          value: agents[i].key,
        })
      }
      getDistributorList();

      getMerchantsList();
      setAgents(arr);
    
    })
    .catch((error) => {
      setLoading(false);
    });
   
  }
  
  const getMerchantsList = (e) => {
    setLoading(true);
    ConfigService.getMerchantDropDown()
    .then((response) => {
        const merchts = response.data.data;
        const arr = [{name:'All Merchants',value:''}];
        for(var i=0; i<merchts.length; i++) {
        
            arr.push({
              name: merchts[i].value,
              value: merchts[i].key,
            })
        }
        listTransactions(false,0,25);
        setMerchants(arr);
   
      })
      .catch(error => {
        setLoading(false);
        console.error("Error fetching agents:", error);
      });
  }



  useEffect(() => {
    let userRole;
    if(userData && userData.user && userData.user.data) {
       userRole = userData.user.data.role.role_code
       setUserRole(userRole)
    }
    if(userRole !='ADMIN') {
      listTransactions(false,0,25,"RAISED");
    } else {

      const updatedColumns = [
        ...columns.slice(0, 4), // Keep the first 4 columns unchanged
        // Add new columns here
       
        ...[{
          name: 'Merchant',
          cell: row => <div className="custom-cell-order_Code">{row.transaction_type == 'PAYIN' ? row.sender_name : row.receiver_name}</div>,
          sortable: true,
         
        },{
          name: 'Distributor',
          cell: row => <div className="custom-cell-order_Code">{row.distributor_name || '-'}</div>,
          sortable: true,
         
        },
        {
          name: 'Agent',
          cell: row => <div className="custom-cell-order_Code">{row.transaction_type == 'PAYIN' ? row.receiver_name : row.sender_name}</div>,
          sortable: true,
         
        },
        {
          name: 'Agent Code',
          cell: row => (
            <div className="custom-cell-order_Code">
              {row.agent_code && row.agent_code.trim() !== '-' ? (
                <a  href="javascript:void(0)" onClick={() => viewAgent(row)}>{row.agent_code}</a>
              ) : (
                '-'
              )}
            </div>
          ),
          sortable: true,
         
        }], 
        ...columns.slice(4), 
      ];
      setColumns(updatedColumns);
      listTransactions(false,0,25,"RAISED");

      getAgents();
      getMerchantsList();
    }
   
    document.body.style.backgroundColor = '#f0f6fa';
    return () => {
      document.body.style.backgroundColor = ''; // Reset body color when ComponentOne unmounts
    };
}, []);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const escapeRegExp = (string) => {
    return string.replace(/[.*+\-?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
  };

  function getStatusText(statusCode) {
    switch (statusCode) {
      case 'I':
        return 'Initiated';
      case 'A':
        return 'Completed';
      case 'AA':
        return 'Agent Accepted';
      case 'RA':
        return 'Raised';
      case 'RM':
        return 'Merchnat Raised';
      case 'F':
        return 'Failed';
      case 'R':
        return 'Rejected';
      case 'MC':
        return 'Cancelled';
        case 'E':
        return 'Expired';
      default:
        return ''; // or handle unknown status codes
    }
  }
  
  const filteredData = transaction && transaction.filter((row) => {
    // Check if any value in the row matches the search term
    return Object.values(row).some((value) => {
      // If value is a status code, convert it to full status text
      if (value === row.status) {
        const statusText = getStatusText(row.status); // Get full status text
        return statusText.toLowerCase().includes(searchTerm.toLowerCase());
      }
      // Otherwise, directly test against the value
      return new RegExp(escapeRegExp(searchTerm), 'i').test(value);
    });
  });


      const handleChange = (e) => {
        const { name, value } = e.target;
        if(name == 'merchantID') {
          setFilterData((prevData) => ({ ...prevData, ['agentID']: '' }));
        }
        if(name == 'agentID') {
          setFilterData((prevData) => ({ ...prevData, ['merchantID']: '' }));
        }
      
        setFilterData((prevData) => ({ ...prevData, [name]: value }));
      
      };
      const applyFilter = () => {
           
        if (filterData.start_date && filterData.end_date) {
          if (new Date(filterData.start_date) > new Date(filterData.end_date)) {
            setErrors((prevErrors) => ({ ...prevErrors, ['start_date']: 'From Date should not be greater than to Date' }));
            setDropdownVisible(true);
            console.log("dropdown true")
            return;

          } else {
            setErrors((prevErrors) => ({ ...prevErrors, ['start_date']: '' }));
            setDropdownVisible(false);
          }
        }
        listTransactions(false, pageNo, rowsPerPage,'RAISED');
      }
      
      const cancelFilter = () => {
        setErrors({
          start_date:''
        })
        setFilterData({
          end_date: '',
          start_date: '',
         agentID:'',
         merchantID:'',
          paymentType: '',
          status:''
      })
      setPageNo(0)
      
      listTransactions(true,0,rowsPerPage,'RAISED');
      }
      const handleRowsPerPageChange = (e) => {
        let rowsPage = Number(e.target.value)
        setRowsPerPage(rowsPage);
        setDataTableKey(prevKey => prevKey + 1);
        listTransactions(false,pageNo, rowsPage,status)
      };
   
      const handlePageChange = page => {
        let pageNumber = page - 1;
        setPageNo(pageNumber)
        listTransactions(false, pageNumber, rowsPerPage,status);
      };
      function getCurrentDate() {
        const today = new Date();
        const year = today.getFullYear();
        let month = today.getMonth() + 1;
        let day = today.getDate();
      
        if (month < 10) {
            month = '0' + month;
        }
        if (day < 10) {
            day = '0' + day;
        }
      
        return `${year}-${month}-${day}`;
      }
      
    return(

      <>
        <LoaderOverlay loading={loading} />
   
        <div className="container-fluid px-4" style={{paddingBottom: '30px'}}>
        <h4 className="updatename updatename1" style={{marginTop: 0, fontWeight: 700, fontSize: '16px'}}>Raised Transaction History</h4>
        <div className="container" style={{backgroundColor: 'white'}}>
          <nav>
            <div className="nav nav-tabs" id="nav-tab" role="tablist">
              <button className="nav-link tbbtn active" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-home" type="button" role="tab" aria-controls="nav-home" aria-selected="true" >Raised Transactions</button>
              {/* <button className="nav-link tbbtn" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false"  onClick={() => resetSearch('Complete')} tabIndex={-1}>Complete Transaction</button> */}
            </div>
          </nav>
          <div className="filterBtn">
                        
                        <div id="examplemgm_filter" className="dataTables_filter"><label><input type="search" className placeholder="Search..."  value={searchTerm}
                        onChange={handleSearchChange} aria-controls="examplemgm" /></label></div>
                                    <div>
                                    <a style={{marginRight: '10px'}} className={`dropdown-toggle noapply ${!isDropdownVisible ? 'show' : ''}`} id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="true">
          <button style={{backgroundColor: 'white !important', color: 'black !important', border: '1px solid #e5e5e5', padding: '3px 10px', borderRadius: '5px', marginTop:'3px', marginBottom: '10px', fontSize: '13px'}} type="button" name="btn_login_details" className="btn">
            <i style={{color: 'black'}} className="fa fa-filter" aria-hidden="true" /> Filter 
          </button>
        </a>
        <div className={`row dropdown-menu dropdown-menu-endd mbv ${isDropdownVisible ? 'show' : ''}`} aria-labelledby="navbarDropdown" style={{display: 'none', position: 'absolute', inset: '0px auto auto 0px', margin: '0px', transform: 'translate3d(43.5556px, 150.222px, 0px)'}} data-popper-placement="bottom-start">
          <div className="col-md-12">
            <h5 className="daterange">Filter</h5>
            <h5 className="sdfgt">Date range</h5>
            <div className="col-md-6" style={{paddingRight: '5px'}}>
              <label style={{fontSize: '13px !important', fontWeight: 'bold !important', color: 'black !important', marginBottom: '5px'}} htmlFor="start_date">From :</label>
              <br />
              <input type="date"  max={getCurrentDate()} value={filterData.start_date} onChange={handleChange} className="form-control" id="start_date" name="start_date" required />
            </div>
            <div className="col-md-6" style={{paddingLeft: '5px'}}>
              <label style={{fontSize: '13px !important', fontWeight: 'bold !important', color: 'black !important', marginBottom: '5px'}} htmlFor="end_date">To :</label>
              <br />
              <input type="date"  max={getCurrentDate()}  value={filterData.end_date} onChange={handleChange} className="form-control" id="end_date" name="end_date" required />
            </div>
            {errors.start_date && <div style={{color:'#dc3545',fontSize: '0.875em',marginTop: '0.25rem'}}>{errors.start_date}</div>}
            <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px'}}>
                <label className htmlFor="Industry">Payment Type</label>
                <select onChange={handleChange}  value={filterData.paymentType} name="paymentType" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value>Select Payment Type</option>
                  <option value="Payin">Payin</option>
                  <option value="Payout">Payout</option>
                </select>
              </div>
            </div>
            <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px'}}>
                <label className htmlFor="Industry">Status</label>
                <select onChange={handleChange}  value={filterData.status} name="status" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  
                  <option value="RAISED">All</option>
                  <option value="RA">Agent Raised</option>
                  <option value="RM">Merchant Raised</option>
                </select>
              </div>
            </div>
            {(role === 'ADMIN' || role === 'DADMIN') && (
  <>
    <div className="col-md-12" style={{ paddingRight: '5px' }}>
      <div className="form-group frm" style={{ textAlign: 'left', marginBottom: '0px' }}>
        <label htmlFor="Industry">Agent</label>
        <select
          name="agentID"
          value={filterData.agentID}
          className="drp"
          onChange={handleChange}
          id="profiles_gender"
          style={{ fontSize: '13px' }}
        >
          <option value="">Select Agent</option>
          {agents.map((agent) => (
            <option key={agent.value} value={agent.value}>
              {agent.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  </>
)}
            {(role =='ADMIN' && 
            <>
          
            <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px'}}>
                <label className htmlFor="Industry">Merchant</label>
                <select onChange={handleChange}   value={filterData.merchantID} name="merchantID" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value="">Select Merchant</option>
                  {merchants.map(merchant => (
          <option key={merchant.value} value={merchant.value}>{merchant.name}</option>
        ))}
                </select>
              </div>
            </div>

            <div className="col-md-12" style={{paddingRight: '5px'}}>
              <div className="form-group frm" style={{textAlign: 'left', marginBottom: '0px'}}>
                <label className htmlFor="Industry">Distributor</label>
                <select onChange={handleChange}   value={filterData.distributorID} name="distributorID" className="drp" id="profiles_gender" style={{fontSize: '13px'}}>
                  <option value="">Select Distributor</option>
                  {distributors.map(merchant => (
          <option key={merchant.value} value={merchant.value}>{merchant.name}</option>
        ))}
                </select>
              </div>
            </div>
            </>

)}
           
                <div className="col-md-12" style={{textAlign: 'right', marginTop: '10px', borderTop: '1px solid #dde0e5'}}>
              <button style={{backgroundColor: 'white', color: 'black', border: '1px solid black', padding: '3px 10px', fontSize:'13px'}} onClick={cancelFilter} type="button" name="btn_login_details" className="btn sebtn" id="cancel_filter">Cancel</button>
              <button style={{padding: '3px 10px', marginLeft:'5px'}} type="submit" name="btn_login_details" id="date_filter" className="btn ddfg sebtn" onClick={applyFilter}>Apply</button>
            </div>
          </div>
        </div>
      </div>
                  </div>
    

                    <div className="dataTables_length" id="examplemgm_length">
                                    <label>Show &nbsp;</label>
                      <select value={rowsPerPage} name="examplemgm_length" onChange={handleRowsPerPageChange}>
                      <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                      </select>
                      &nbsp;entries
                    </div>
          <div className="tab-content" id="nav-tabContent" style={{paddingTop: '15px', paddingBottom: '15px'}}>
            <div className="tab-pane fade active show" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
              <main>
                <div className style={{paddingBottom: '30px'}}>
                  <div className style={{backgroundColor: 'white'}}>
                    <div className="tab-content" id="nav-tabContent" style={{}}>
                      <div className="tab-pane fade show active" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="col-md-12" style={{textAlign: 'right'}}>
                    
      </div>
                       
                        <div id="examplemgmwallet_wrapper" className="dataTables_wrapper dt-jqueryui no-footer">

                        <DataTable key={dataTableKey}
                            columns={columns}
                              data={filteredData}
                              pagination
                              paginationComponentOptions={paginationComponentOptions} 
                              paginationPerPage={rowsPerPage} 
                              paginationServer
                              paginationTotalRows={totalRows}
                              onChangePage={handlePageChange}
                        />
                        
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </main>
            </div>
     
          </div>
        </div>
      </div>
      </>
    )
}

function mapStateToProps(state) {
    const userData = state.authReducer.user;
    return { userData };
  }
export default withAuth(connect(mapStateToProps)(RaisedTransactionList));